import { render } from "./qs-lead-display.vue?vue&type=template&id=c21f8a56&scoped=true&ts=true"
import script from "./qs-lead-display.vue?vue&type=script&lang=ts"
export * from "./qs-lead-display.vue?vue&type=script&lang=ts"

import "./qs-lead-display.vue?vue&type=style&index=0&id=c21f8a56&lang=scss&scoped=true"
/* custom blocks */
import block0 from "../i18n/messages.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3593438386%2Fsrc%2Fpadme-ui-aws%2Fapps%2Fmain%2Fsrc%2Flayouts%2Fmain%2Fcomponents%2Fleft-menu%2Fcomponents%2Fquick-search%2Fcomponents%2Fqs-lead-display.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21f8a56"]])

export default __exports__